import { SkeletonLoader } from '@toggle/design-system';
import { PriceStatus, Status } from '@toggle/helpers';
import styled from 'styled-components';

import { priceChangeColors } from '~/utils/common/utils';

export const PriceWrapper = styled.div<{
  $status: PriceStatus | Status;
  $alignment?: string;
}>`
  color: ${({ $status }) => priceChangeColors[$status]};
`;

export const Unit = styled.span`
  font-size: 8px;
  line-height: 12px;
  margin-top: 6px;
  margin-left: 5px;
`;

const indicatorStatus = {
  default: 'var(--base--60)',
  livePrice: 'var(--viz-bullish)',
};

export const Indicator = styled.div<{
  $status: 'livePrice' | 'default';
}>`
  margin-left: 10px;
  border-radius: 50%;
  width: 8px;
  height: 8px;
  background-color: ${({ $status }) => indicatorStatus[$status]};
`;

export const FlexRowWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: flex-end;
  flex-direction: row;
  gap: 4px;
`;

export const StyledSkeletonLoader = styled(SkeletonLoader).attrs({
  areas: [
    {
      styles: {
        width: '40px',
        height: '20px',
        borderRadius: '8px',
      },
    },
  ],
})`
  display: flex;
  justify-content: flex-end;
`;
